import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { TemplateSelection } from 'app/apps/template-selection.model';
import { PreviewFormComponent } from 'app/form/edit-form/preview-form/preview-form.component';
import { SegmentService } from 'app/segment/segment.service';
import { TemplateWeb } from 'app/shared/model/template.model';

@Component({
  selector: 'cc-templates-selector-card',
  templateUrl: 'templates-selector-card.component.html',
  styleUrls: ['templates-selector-card.component.scss'],
})
export class TemplatesSelectorCardComponent {
  @Input() template: TemplateWeb;
  @Input() isLibrarySelection: boolean;
  @Output() toggleSelection = new EventEmitter<TemplateSelection>();

  public modalReference: NgbModalRef;
  constructor(private readonly modal: NgbModal, private readonly segmentService: SegmentService) {}

  onCardClick() {
    this.template.selected = !this.template.selected;
    this.onToggleSelection();
  }

  onToggleSelection() {
    this.toggleSelection.emit({
      templateId: this.template._id,
      isSelected: this.template.selected,
    });
  }

  preventPropagationOnClick(event) {
    event.stopPropagation();
  }

  onPreviewClick() {
    void EventNotifierService.notify(
      new DashpivotEvent(EventTypes.TemplatePreviewOpened, { Context: this.template?.uniqueAppId }),
      this.segmentService,
    );

    this.modalReference = this.modal.open(PreviewFormComponent, {
      backdrop: 'static',
      windowClass: 'form-modal full-modal',
    });

    this.modalReference.componentInstance.templateId = this.template.id;
    this.modalReference.componentInstance.isPreview = true;
    this.modalReference.componentInstance.isCompanyLibrary = !this.isLibrarySelection;
    this.modalReference.componentInstance.counterIsActivated = this.template.counterIsActivated;
    this.modalReference.componentInstance.templateUniqueAppId = this.template.uniqueAppId;
    this.modalReference.componentInstance.templateName = this.template.name;
    this.modalReference.componentInstance.templateOrientation = this.template.orientation;

    this.modalReference.result
      .then(() => {
        this.template.selected = true;
        this.onToggleSelection();
        return true;
      })
      .catch(() => {
        // no-op
      });
  }
}
